<template>
  <div id="dashboard" class="main-container container">
    <section class="sections">
      <div class="columns">
        <div class="column col1">
          <div class="profile card">
            <div class="create-post">
              <form @submit.prevent>
                <p>Crea una nueva galeria</p>
                <input class="input" type="text" v-model.trim="gallery.name" />
                <button
                  @click="createGallery()"
                  :disabled="
                    gallery.name === '' || userProfile.role !== 'admin'
                  "
                  class="button is-primary"
                >
                  Crear
                </button>
              </form>
            </div>
          </div>
        </div>
        <div class="column col2">
          <div v-if="galleries.length">
            <v-data-table
              :headers="headers"
              :items="galleries"
              :items-per-page="100"
              class="elevation-1"
            >
              <template v-slot:[`item.name`]="{ item }">
                <router-link v-bind:to="'/gallery/' + item.id">
                  <i class="material-icons delete-btn">image</i>
                  <span class="item-name">
                    {{ item.name }}
                  </span>
                </router-link>
              </template>
              <template v-slot:[`item.createdOn.seconds`]="{ item }">
                <span class="item-created">
                  {{ item.createdOn | formatDMYDate }}
                </span>
              </template>

              <template v-slot:[`item.images`]="{ item }">
                <router-link v-bind:to="'/gallery-edit/' + item.id">
                  {{ item.photos_detected }}/{{ item.photos }}
                </router-link>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <router-link v-bind:to="'/gallery-edit/' + item.id">
                  <i class="material-icons delete-btn">edit</i>
                </router-link>
              </template>
              <template v-slot:[`item.upload`]="{ item }">
                <router-link v-bind:to="'/gallery-upload/' + item.id">
                  <i class="material-icons delete-btn">cloud_upload</i>
                </router-link>
              </template>
              <template v-slot:[`item.participants`]="{ item }">
                <router-link
                  v-bind:to="'/participants/' + item.id"
                  v-if="item.validateNumbersToBuy"
                >
                  <i class="material-icons delete-btn">people</i>
                </router-link>
                <i
                  v-if="!item.validateNumbersToBuy"
                  class="material-icons delete-btn has-text-grey-lighter"
                  >people</i
                >
              </template>
              <template v-slot:[`item.test`]="{ item }">
                <a
                  target="_blank"
                  :href="
                    'https://www.findupix.com/comprar-fotos/?gallery_id=' +
                    item.id
                  "
                >
                  <i class="material-icons delete-btn">trending_up</i>
                </a>
              </template>
            </v-data-table>
          </div>
          <div v-else>
            <p class="no-results">No hay galerias</p>
          </div>
        </div>
      </div>
    </section>
    <div class="notification is-warning" v-if="userProfile.role !== 'admin' ">
      <!-- <button class="delete"></button> -->
      Atención, usted ha accedido con acceso limitado, no podrá crear ni editar galerias.
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebase");

export default {
  components: {},
  data() {
    return {
      gallery: {
        name: "",
        detectText: true,
      },
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      headers: [
        {
          text: "Nombre",
          align: "start",
          value: "name",
        },
        // { text: 'Imágenes', value: 'images' },
        { text: "Ajustes", value: "actions" },
        { text: "Subir fotos", value: "upload" },
        { text: "Participantes", value: "participants" },
        { text: "Ir a Findupix", value: "test" },
        { text: "Fecha creación", value: "createdOn.seconds" },
      ],
    };
  },
  computed: {
    ...mapState(["userProfile", "galleries"]),
  },
  methods: {
    createGallery() {
      this.$store.dispatch("createGallery", { name: this.gallery.name });
      this.gallery.name = "";
    },
    closePostModal() {
      this.postComments = [];
      this.showPostModal = false;
    },
    async deleteGallery(id) {
      const result = await this.$swal({
        title: "Delete?",
        text: `¿Are you sure to delete the gallery?`,
        icon: "question",
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
      });
      if (result.value) {
        // const galleryRef = await fb.galleriesCollection.doc(id).update({
        //   deleted: true
        // })
        this.$router.push("home");
      }
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
    formatDMYDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
.delete-btn {
  padding: 0;
  color: #6c757d;
  cursor: pointer;
}
.item-name {
  vertical-align: 7px;
  padding-left: 1rem;
}
.main-container {
  margin-top: 70px;
}
</style>
